export const DEFAULT_COLUMN_WIDTH = 200;

export const CHECKBOX_COLUMN_WIDTH = 50;

export const OPTIONS_COLUMN_WIDTH = 120;
